goog.provide('el8.ptdata.model.noteItem');

goog.require('el8.template.ptdata.model.noteItem');
goog.require('el8.data.referencedUsers');

// ----------------
// NOTE ITEM
//  * reports
//  * lab results
// ----------------
(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeRecorded();
    _class.addStringProperty("text", true);

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        delete mapped['userId'];
        mapped['userName'] = el8.data.referencedUsers.getById(this.getUserId()).getFullName();
        return mapped;
    };

    el8.ptdata.model.noteItem = function(spec) {
        return new _class(spec);
    };

})();

